export const PROMOTION_DATA = "PROMOTION_DATA";
export const USER_MANAGEMENT_ADMIN_LIST = "USER_MANAGEMENT_ADMIN_LIST";
export const USER_MANAGEMENT_USER_LIST = "USER_MANAGEMENT_USER_LIST";
export const OFFERS_LIST = "OFFERS_LIST";
export const SUPER_ADMIN_LIST = "SUPER_ADMIN_LIST";
export const OPERATOR_LIST = "OPERATOR_LIST";
export const GET_EMPLOYEE_LIST = "GET_EMPLOYEE_LIST";
export const COMPANY_PROFILE = "COMPANY_PROFILE";
export const GET_PARTNER_LIST = "GET_PARTNER_LIST";
export const ADS_LIST = "ADS_LIST";
export const GET_ADS = "GET_ADS";
export const REQUEST_MANAGEMENT_DATA = "REQUEST_MANAGEMENT_DATA";
export const GET_ROLE_NAME = "GET_ROLE_NAME";
export const GET_PERMISSIONS = "GET_PERMISSIONS";
export const GET_ROLES = "GET_ROLES";
export const REQ_PROMOTION_DATA = "REQ_PROMOTION_DATA";
export const CLIENT_DATA = "CLIENT_DATA";
export const IMPORT_DATA_LIST = "IMPORT_DATA_LIST";
export const COMPANY_SETTING = "COMPANY_SETTING";
export const EMPLOYEE_DOC = "EMPLOYEE_DOC";
export const OPERATOR_DOC = "OPERATOR_DOC";
export const PARTNER_DOC = "PARTNER_DOC";
export const GET_SUBSCRIPTION = "GET_SUBSCRIPTION";
export const FORGOT_PASSWORD = "FORGOT_PASSWORD";
export const PRODUCT_OWNER_DATA = "PRODUCT_OWNER_DATA";
export const UNREAD_NOTIFICATION = "UNREAD_NOTIFICATION";
export const NOTIFICATION_DATA = "NOTIFICATION_DATA";
export const GET_ADS_CLIENT = "GET_ADS_CLIENT";
export const GET_PERMISSION_COUNT = "GET_PERMISSION_COUNT";
export const GET_ROLES_COUNT = "GET_ROLES_COUNT";
export const GET_OPERATOR_NAME = "GET_OPERATOR_NAME";
export const USER_SETTINGS_EDIT = "USER_SETTINGS_EDIT";
export const GET_OP_EMP_COUNT = "GET_OP_EMP_COUNT";
export const GET_PRO_EMP_COUNT = "GET_PRO_EMP_COUNT";
export const GET_MOBILE_ADS = "GET_MOBILE_ADS";
export const GET_OPERATOR_EMAILID = "GET_OPERATOR_EMAILID";
export const GET_ALL_EMAIL_INFO = "GET_ALL_EMAIL_INFO";
export const GET_RECENT_ADS = "GET_RECENT_ADS";
export const GET_RECENT_OFFERS = "GET_RECENT_OFFERS";
export const GET_RECENT_PROMOFILE = "GET_RECENT_PROMOFILE";
export const REQ_MAN_OFFERS = "REQ_MAN_OFFERS";
export const GET_REQ_ADS = "GET_REQ_ADS";
export const OPERATOR_BYID = "OPERATOR_BYID";
export const PARTNER_BYID = "PARTNER_BYID";
export const BIN_DATA = "BIN_DATA";
export const TBS_INFO = "TBS_INFO";
export const REFER_EARN = "REFER_EARN";
export const REDEEM_OFFER = "REDEEM_OFFER";
export const OPERATOR_DATA = "OPERATOR_DATA";
export const PROMO_BG_IMAGE = "PROMO_BG_IMAGE";
export const GET_REQ_PARTNER = "GET_REQ_PARTNER";
export const GET_ROLES_PERMISSION = "GET_ROLES_PERMISSION";
export const GET_REQ_MOB_ADS = "GET_REQ_MOB_ADS"
export const THEME_BACKGROUND = "THEME_BACKGROUND" 
// export const GET_BG_IMAGE = "GET_BG_IMAGE"
// export const STARTER_IMAGE = "STARTER_IMAGE"
export const GET_BOOKING_DETAILS = "GET_BOOKING_DETAILS"
export const GET_DASHBOARD_DETAILS = "GET_DASHBOARD_DETAILS"
export const GET_CANCELLATION_DETAILS = "GET_CANCELLATION_DETAILS"
export const GET_PASSENGER_DETAILS = "GET_PASSENGER_DETAILS"
export const GET_BLOCKED_DETAILS = "GET_BLOCKED_DETAILS"
export const GET_ALL_MOBILE_NUMBERS = "GET_ALL_MOBILE_NUMBERS"
export const GET_AVAILABLE_BALANCE = "GET_AVAILABLE_BALANCE"
export const GET_PAYMENT_DETAILS = "GET_PAYMENT_DETAILS"
export const GET_SETTLEMENT_DETAILS = "GET_SETTLEMENT_DETAILS"
export const GET_REFUND_DETAILS = "GET_REFUND_DETAILS"
export const GET_USAGE_DETAIL="GET_USAGE_DETAIL";
export const GET_BARCHART_DETAILS = "GET_BARCHART_DETAILS"
export const GET_MOBILE_NOTIFICATION = "GET_MOBILE_NOTIFICATION"
export const GET_ACCESSID = "GET_ACCESSID"
export const GET_TBS_DEAL = "GET_TBS_DEAL"
export const GET_ABHIBUS_HISTORY = "GET_ABHIBUS_HISTORY"
export const GET_PAT_DASHBOARD_DETAILS = "GET_PAT_DASHBOARD_DETAILS"
export const GET_PAT_INSTALL_DETAILS = "GET_PAT_INSTALL_DETAILS"
export const GET_PAT_BOOKING_DETAILS = "GET_PAT_BOOKING_DETAILS"
export const GET_SETTLEMENT_DETAILS_BY_MONTH="GET_SETTLEMENT_DETAILS_BY_MONTH"
export const GET_REFUND_REQUEST="GET_REFUND_REQUEST"
export const GET_USER="GET_USER"
export const GET_NUMBER="GET_NUMBER"
export const RESETNUMBER="RESETNUMBER"
export const GET_COMMISSION="GET_COMMISSION"
export const GET_RAZORPAY_DETAILS="GET_RAZORPAY_DETAILS"
export const GET_APP_VERSIONINFO="GET_APP_VERSIONINFO"
//Super Admin Vault
export const CREDENTIALS_LIST = "CREDENTIALS_LIST";
export const DOCUMENTS_LIST = "DOCUMENTS_LIST";
export const ADMIN_ACTIVITY_LOG = "ADMIN_ACTIVITY_LOG"
export const CONTACTS_LIST = "CONTACTS_LIST";